<template>
  <v-card outlined>
    <v-card-text>
      <p>Trigger a notificaiton in 10 seconds.</p>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        depressed
        :loading="loading"
        color="primary"
        @click.stop="save"
      >
        Notify Me!
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
   data: () => ({
      loading: false,
      form: {
         password: null,
      }
   }),

   methods: {
      async save () {
         this.loading = true
         await this.$inertia.post(this.route('demo.notifications.store'), this.form).then(() => {
            this.loading = false
         })
      }
   }
}
</script>
